import clsx from "classnames";
import classes from "./styles.module.scss";

export default function Breadcrumb({ label, className }) {

  return (
    <div className={clsx(className, classes.breadcrumb)}>
      <a href="/">Home</a>
      <span>/</span>
      <span>{label}</span>
    </div>
  );
}

Breadcrumb.defaultProps = {
  className: "",
};
